import styled from 'styled-components';

export const ShareContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

export const ShareButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #667eea;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  background-color: white;
  color: #667eea;
  transition: all 0.2s;
  
  &:hover {
    background-color: #667eea;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const ShareMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  overflow: hidden;
  margin-top: 5px;
  animation: slideDown 0.2s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ShareItem = styled.button`
  width: 100%;
  padding: 12px 15px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.2s;
  
  .icon {
    font-size: 18px;
    width: 24px;
    text-align: center;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:active {
    background-color: #e8e8e8;
  }
  
  & + & {
    border-top: 1px solid #f0f0f0;
  }
`;

export const CopyLinkButton = styled(ShareItem)`
  background-color: #f8f8f8;
  font-weight: bold;
  color: #667eea;
  
  &:hover {
    background-color: #efefef;
  }
`;
